import React from 'react';
import { Card } from './ui/card';
import { Phone, Mail, MapPin } from 'lucide-react';

const Contact = ({ contact, hospitalName }) => {
  return (
    <section id="contact" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              Contact Information
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              For consultations and inquiries, please reach out through the following channels
            </p>
            <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full mt-6"></div>
          </div>
          
          <div className="grid sm:grid-cols-2 gap-6">
            {/* Email Card */}
            <Card className="p-8 border-slate-200 hover:border-teal-300 hover:shadow-xl transition-all duration-300 group">
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="p-4 bg-teal-100 rounded-xl group-hover:bg-teal-600 group-hover:scale-110 transition-all duration-300">
                  <Mail className="w-8 h-8 text-teal-600 group-hover:text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900">Email Address</h3>
                <a
                  href={`mailto:${contact?.email}`}
                  className="text-lg text-teal-600 hover:text-teal-700 font-medium break-all"
                >
                  {contact?.email}
                </a>
              </div>
            </Card>
            
            {/* Phone Card */}
            <Card className="p-8 border-slate-200 hover:border-teal-300 hover:shadow-xl transition-all duration-300 group">
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="p-4 bg-teal-100 rounded-xl group-hover:bg-teal-600 group-hover:scale-110 transition-all duration-300">
                  <Phone className="w-8 h-8 text-teal-600 group-hover:text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900">Phone Number</h3>
                <div className="space-y-2">
                  <a
                    href={`tel:${contact?.phone}`}
                    className="block text-lg text-teal-600 hover:text-teal-700 font-medium"
                  >
                    {contact?.phone}
                  </a>
                  <p className="text-sm text-slate-500">Direct Contact</p>
                </div>
              </div>
            </Card>
          </div>
          
          {/* Hospital Contact */}
          <Card className="mt-6 p-8 border-slate-200 bg-white">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-teal-100 rounded-lg">
                  <MapPin className="w-6 h-6 text-teal-600" />
                </div>
                <div>
                  <h4 className="text-lg font-bold text-slate-900 mb-1">{hospitalName}</h4>
                  <p className="text-slate-600">Hospital Switchboard</p>
                </div>
              </div>
              <a
                href={`tel:${contact?.hospitalPhone}`}
                className="px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors"
              >
                {contact?.hospitalPhone}
              </a>
            </div>
          </Card>
          
          <div className="mt-8 p-6 bg-teal-50 rounded-lg border border-teal-200">
            <p className="text-center text-slate-700">
              <strong>Note:</strong> This is a professional profile website. For appointment scheduling, please contact the hospital directly.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;